import { isLoggedInState } from "@/atoms/accountState";
import { matchRequestCompareLoadingState } from "@/atoms/match/matchRequestLoadingState";
import { matchRequestResDataState } from "@/atoms/match/matchRequestResDataState";
import { quotationRequestState } from "@/atoms/quotationRequestState";
import { SangjoCompareRequestProps } from "@/containers/MatchContainer/type/requestType";
import { useSangjoQuotationRequestExistModal } from "@/hooks/useSangjoQuotationRequestExistModal";
import { Axios } from "@/utils/axios";
import { Box } from "@chakra-ui/react";
import { useRemoteConfig } from "@hackler/react-sdk";
import { useOverlay } from "@toss/use-overlay";
import axios from "axios";
import { 장례식장_가격_시설_LIST } from "containers/MatchContainer/constants/request";
import {
  ChatbotModalContent,
  cooKeys,
  customEvent,
  Field,
  getCookie,
  HStack,
  LargeButton,
  LARGEL_BUTTON_TYPE,
  OverlayModal,
  setCookie,
  Spacing,
  Spinner,
  useResponsive,
  VStack,
} from "goi_common";
import { useRouter } from "next/router";
import { useCallback, useMemo, useReducer } from "react";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";

const 고민_LIST = [
  "장례식장에서 견적을 받았는데 너무 비싸요.",
  "1000만원, 2000만원 지나친 비용이 걱정돼요.",
  "장례를 믿고 맡길 장례지도사가 중요해요.",
  "선불제 상조를 가입한 상태에요.",
  "공설 위주로 맞춤형, 합리적으로 알아보고 있어요.",
  "프리미엄 장례를 희망해요.",
  "없음",
];
function MatchCompareDetailRequest() {
  const { isBiggerThanMd } = useResponsive();

  const responseData = useRecoilValue<any>(matchRequestResDataState);
  const setQuotationRequest = useSetRecoilState(quotationRequestState);
  const router = useRouter();
  const [loading, setLoading] = useRecoilState(matchRequestCompareLoadingState);
  const isLoggedIn = useRecoilValue(isLoggedInState);

  const { onOpenRequestExistModal } = useSangjoQuotationRequestExistModal();

  const remoteConfig = useRemoteConfig();
  const isChatbotOpen = remoteConfig.get("is_chatbot_open", false);
  const overlay = useOverlay();
  const [SelectedOption, setSelectedOption] = useReducer(
    (prev: SangjoCompareRequestProps, next: any) => {
      return { ...prev, ...next };
    },
    {
      장례식장_가격_시설: "",
      고민: "",
    },
  );

  const isDisabled = useMemo(() => {
    return !SelectedOption.장례식장_가격_시설 || !SelectedOption.고민;
  }, [SelectedOption]);

  const handleSubmit = useCallback(async () => {
    if (loading) return;
    customEvent({
      newGtm: {
        path: "match_request",
        trigger_and_target: "submit_detail_request-non_member",
      },
    });

    const previousRequestedQuotation = getCookie(cooKeys.quotation_request);

    try {
      const { data } = await Axios.patch(
        `/sangjo_quotation_requests/${previousRequestedQuotation.id}/`,
        {
          memo: `장례식장 선호: ${SelectedOption.장례식장_가격_시설}, 고민: ${SelectedOption.고민}`,
        },
      );

      if (!isLoggedIn) {
        setCookie(
          cooKeys.quotation_request,
          JSON.stringify({ ...data, id: previousRequestedQuotation.id }),
        );
        setQuotationRequest(responseData);

        if (!isChatbotOpen) {
          router
            .push(
              `/login?event_from=uv_mtch_rqst&redirectTo=${encodeURIComponent(`/match/request/`)}`,
            )
            .then((res) => {
              setLoading(false);
            });
        } else {
          overlay.open(({ isOpen, close: onCloseOverlay }) => {
            return (
              <OverlayModal
                onClose={onCloseOverlay}
                isOpen={isOpen}
                modalContentStyle={{
                  minWidth: "340px",
                  overflow: "scroll",
                }}
                overlayModalContent={
                  <ChatbotModalContent
                    onClose={() => {
                      onCloseOverlay();
                      setLoading(false);
                    }}
                  />
                }
              />
            );
          });
        }
      } else {
        router.push(
          `/match/request-complete?id=${responseData.id}&sido=${responseData.funeral_sido}&sigungu=${responseData.funeral_sigungu}`,
        );
      }
    } catch (e) {
      if (axios.isAxiosError(e) && e.response?.status === 401) {
        onOpenRequestExistModal();
      }
    }
  }, [SelectedOption]);

  return (
    <>
      <VStack padding="24px 24px 24px 24px" width="100%">
        <Field.Radio
          title="어떠한 장례식장을 찾고 계신가요?"
          items={장례식장_가격_시설_LIST}
          value={SelectedOption.장례식장_가격_시설}
          onChange={(e) => {
            setSelectedOption({ 장례식장_가격_시설: e });
            customEvent({
              newGtm: {
                path: "match_request",
                trigger_and_target: "parlor_price-answer",
                text: String(e),
              },
            });
          }}
          radioWidth="100%"
          flexDirection="column"
        />

        <Spacing gap={48} />
        <Field.Radio
          title="장례 준비 중 고민이 있으신가요?"
          items={고민_LIST}
          value={SelectedOption.고민}
          onChange={(e) => {
            setSelectedOption({ 고민: e });
            customEvent({
              newGtm: {
                path: "match_request",
                trigger_and_target: "worry-answer",
                text: String(e),
              },
            });
          }}
          radioWidth="100%"
          flexDirection="column"
        />
        <Spacing gap={108} />
      </VStack>

      <HStack
        position="fixed"
        style={{
          bottom: 0,
          marginTop: "110px",
        }}
        width={isBiggerThanMd ? "480px" : "100%"}
        maxWidth={isBiggerThanMd ? "var(--global-max-width)" : "480px"}
      >
        <LargeButton
          buttonType={isDisabled ? LARGEL_BUTTON_TYPE.DISABLED : LARGEL_BUTTON_TYPE.PRIMARY}
          disabled={isDisabled}
          borderRadius={0}
          height={60}
          onClick={handleSubmit}
        >
          <Box display="flex">{loading ? <Spinner /> : "비용 알아보기"}</Box>
        </LargeButton>
      </HStack>
    </>
  );
}

export default MatchCompareDetailRequest;
